// export const BASE_URL = 'http://165.22.212.233:8002/';
export const BASE_URL = 'https://mis.3domg.com/';